import React from "react"
import { Controller, useFormContext } from "react-hook-form"

import Form from "src/components/Form"

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

const ContactFieldGroup = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext()
  const contactErrors = errors?.contact || {}

  return (
    <div className="flex flex-col gap-3">
      <div>
        <Form.Label htmlFor="inline-contact-name" required>
          Full Name
        </Form.Label>
        <Controller
          name="contact.name"
          control={control}
          rules={{ required: "Full name is required" }}
          render={({ field }) => (
            <Form.TextField
              id="inline-contact-name"
              required
              hasErrors={!!contactErrors.name}
              {...field}
            />
          )}
        />
        {contactErrors.name && (
          <Form.Error>{contactErrors.name.message}</Form.Error>
        )}
      </div>

      <div className="flex flex-col gap-3 sm:flex-row">
        <div className="flex-1">
          <Form.Label htmlFor="inline-contact-email" required>
            Email
          </Form.Label>
          <Controller
            name="contact.email"
            control={control}
            rules={{
              required: "Email is required",
              pattern: { value: EMAIL_PATTERN, message: "Enter a valid email" },
            }}
            render={({ field }) => (
              <Form.TextField
                id="inline-contact-email"
                type="email"
                required
                hasErrors={!!contactErrors.email}
                {...field}
              />
            )}
          />
          {contactErrors.email && (
            <Form.Error>{contactErrors.email.message}</Form.Error>
          )}
        </div>

        <div className="flex-1">
          <Form.Label htmlFor="inline-contact-phone">Phone</Form.Label>
          <Controller
            name="contact.phone"
            control={control}
            render={({ field: { onChange, value } }) => (
              <Form.TelephoneField
                id="inline-contact-phone"
                onChange={onChange}
                value={value}
              />
            )}
          />
        </div>
      </div>
    </div>
  )
}

export default ContactFieldGroup
